import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

export const Root = styled('div')(({ theme }) => ({
  width: 'min(100%, 200px)',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '20px',
  border: `1px solid ${theme.palette.border}`,
  overflow: 'hidden',
}));

export const PreviewContainer = styled('div')({
  flexShrink: 0,
  width: '100%',
  height: 100,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'radial-gradient(112.40% 111.44% at 50.00% 50.00%, #EDF5F8 6.11%, #CADDE8 100%)',
  overflow: 'hidden',
  padding: '20px 24px 0'
});

export const Preview = styled(Box)({
  display: 'block',
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'top',
  borderRadius: '4px 4px 0 0'
});

export const ContentContainer = styled('div')(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  background: theme.palette.background.default,
  padding: 8,
}));

export const Header = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
}));

export const Title = styled((props) => (
  <Typography variant='body2' noWrap {...props} />
))(() => ({
  flexGrow: 1,
  textTransform: 'uppercase',
  paddingRight: 10,
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: 'unset',
  height: 18,
  lineHeight: 1,
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.primary.main,
  padding: '0 2px',
}));

export const MenuButton = styled(Button)(({ theme }) => ({
  minWidth: 'unset',
  color: theme.palette.primary.main,
  padding: 0,
  marginRight: '-4px',
}));